var map = {
	"./ss1.jpg": 31,
	"./ss2.jpg": 5072,
	"./ss3.jpg": 2173,
	"./ss4.jpg": 8822,
	"./ss5.jpg": 9875,
	"./ss6.jpg": 8068,
	"./ss7.jpg": 6593,
	"./ss8.jpg": 7066,
	"./ss9.jpg": 9719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1271;